import React, { useEffect, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { api } from "../services/api";
import PageHeader from "./ui/PageHeader";
import DataCard from "./ui/DataCard";
import LoadingState from "./ui/LoadingState";
import AlertBanner from "./ui/AlertBanner";

const BillPaymentsHub = () => {
  const [categories, setCategories] = useState([]);
  const [operators, setOperators] = useState([]);
  const [selectedCode, setSelectedCode] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .getBillPayments()
      .then(setCategories)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const loadOperators = async (code) => {
    setSelectedCode(code);
    try {
      setOperators(await api.getOperators(code));
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <LoadingState message="Loading bill services..." />;

  const selected = categories.find((c) => c.code === selectedCode);

  return (
    <div>
      <PageHeader
        title="Bill Payments"
        subtitle="BBPS-enabled services — Electricity, Mobile, DTH, Water & more (India)"
      />

      {error && <AlertBanner type="danger" message={error} onClose={() => setError(null)} />}

      <Row className="g-3 mb-4">
        {categories.map((cat) => (
          <Col md={6} lg={4} xl={3} key={cat.code}>
            <div
              className={`service-tile${selectedCode === cat.code ? " active" : ""}`}
              onClick={() => loadOperators(cat.code)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && loadOperators(cat.code)}
            >
              <div className="service-tile-icon">{cat.icon}</div>
              <h6>{cat.name}</h6>
              <p className="small text-muted mb-2">
                {cat.txnCount} txns · {cat.successRate}% success
              </p>
              <div className="d-flex gap-2 flex-wrap">
                <span className="billr-badge success">{cat.totalVolume}</span>
                {cat.failedCount > 0 && (
                  <span className="billr-badge danger">{cat.failedCount} failed</span>
                )}
              </div>
            </div>
          </Col>
        ))}
      </Row>

      {selectedCode && (
        <DataCard title={`Operators — ${selected?.name}`}>
          <Table responsive className="billr-table mb-0">
            <thead>
              <tr>
                <th>Operator</th>
                <th>Code</th>
                <th>Circle / Region</th>
              </tr>
            </thead>
            <tbody>
              {operators.length === 0 ? (
                <tr>
                  <td colSpan={3} className="text-center text-muted py-4">
                    No operators configured
                  </td>
                </tr>
              ) : (
                operators.map((op) => (
                  <tr key={op.operator_code}>
                    <td><strong>{op.operator_name}</strong></td>
                    <td><code>{op.operator_code}</code></td>
                    <td>{op.circle || "Pan India"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </DataCard>
      )}
    </div>
  );
};

export default BillPaymentsHub;
